import React from 'react';
import { Link } from 'react-router-dom';
import Header from 'core/layout/Header';
import Footer from 'core/layout/Footer';
import { useTranslation } from 'core/context/TranslationContext';

/*
 * Static content pages linked from the footer.
 * NOTE: Privacy / Terms are short placeholders and must be replaced with
 * reviewed legal text; Contact needs a real support address.
 */
const PAGES = {
    about: {
        title: 'About us',
        lead: 'Job Flow Connect is a career platform that brings job seekers and employers together.',
        sections: [
            { h: 'What we do', p: 'We help candidates discover roles, build a professional CV and apply in a few clicks, while employers post jobs, browse candidate profiles and manage applications from one dashboard.' },
            { h: 'Who it is for', p: 'Job seekers who want a simpler way to get hired, and hiring teams who want to reach the right people faster.' }
        ]
    },
    contact: {
        title: 'Contact',
        lead: 'Questions, feedback or partnership ideas? We would like to hear from you.',
        sections: [
            { h: 'Get in touch', p: 'Reach the team through our website at jobflowconnect.com. If you already have an account, sign in and include your registered email so we can help faster.' }
        ]
    },
    help: {
        title: 'Help center',
        lead: 'Quick answers to the most common questions.',
        sections: [
            { h: 'How do I apply for a job?', p: 'Open any job from Browse Jobs, review the details and choose Apply. You can track your applications from your dashboard once you are signed in.' },
            { h: 'How do I build a CV?', p: 'Use the CV Builder to create a CV from your profile, then share it with a link or download it.' },
            { h: 'How do I post a job?', p: 'Create an employer account, set up your company profile and post a job from your employer dashboard.' }
        ]
    },
    privacy: {
        title: 'Privacy policy',
        lead: 'How we handle your information.',
        sections: [
            { h: 'Your data', p: 'We collect the information you provide (such as your profile, CV and applications) to operate the service and connect you with employers. This page is a summary and will be replaced by the full privacy policy.' }
        ]
    },
    terms: {
        title: 'Terms of use',
        lead: 'The rules for using Job Flow Connect.',
        sections: [
            { h: 'Using the service', p: 'By using Job Flow Connect you agree to provide accurate information and to use the platform lawfully. This page is a summary and will be replaced by the full terms.' }
        ]
    }
};

function InfoPage({ page }) {
    const { _t } = useTranslation();
    const content = PAGES[page];

    return (
        <>
            <Header />
            <main className="jf-public jf-info">
                <div className="jf-container">
                    <article className="jf-info__body">
                        <h1>{_t(content.title)}</h1>
                        <p className="jf-info__lead">{_t(content.lead)}</p>
                        {content.sections.map((s) => (
                            <section key={s.h}>
                                <h2>{_t(s.h)}</h2>
                                <p>{_t(s.p)}</p>
                            </section>
                        ))}
                        <p style={{ marginTop: 32 }}><Link to="/">← {_t('Back to home')}</Link></p>
                    </article>
                </div>
            </main>
            <Footer />
        </>
    );
}

export default InfoPage;
